import Box from "@mui/material/Box";

const ProjectViewPanel = ({
  ariaId,
  ariaLabelledBy,
  children,
  hidden,
}) => (
  <Box
    aria-labelledby={ariaLabelledBy}
    component="div"
    id={ariaId}
    role="tabpanel"
    sx={{
      borderRadius: "0 0 4px 4px",
      flexGrow: 1,
      overflow: "auto",
      minHeight: 0,
      m: 0,
      p: 0,
      ...(hidden && { display: "none" }),
    }}
  >
    <Box component="div">
      {children}
    </Box>
  </Box>
);

export default ProjectViewPanel;
